export function DocChronologyEmptyStateIllustration() {
  return (
    <div className="mb-6 flex h-24 w-xs items-center justify-center">
      <div className="flex h-full flex-col items-center">
        <div className="w-0.5 grow bg-gray-200 mask-t-from-10%"></div>
        <div className="size-3.5 rounded-full border-2 border-gray-300 bg-gray-50"></div>
        <div className="w-0.5 grow bg-gray-200 mask-b-from-10%"></div>
      </div>

      <div className="mx-5 mr-8 grow overflow-hidden rounded-lg border bg-white shadow-lg/3">
        {/* Document */}
        <div className="p-2">
          <div className="mb-1.5 flex items-center gap-1">
            <div className="h-2.5 w-10 rounded-sm bg-gray-200/80"></div>
          </div>
          <div className="mb-1 h-2 w-full rounded-sm bg-gray-200/50"></div>
          <div className="h-2 w-2/3 rounded-sm bg-gray-200/50"></div>
        </div>

        {/* Facts associated with the document */}
        <div className="flex flex-col gap-1.5 border-t border-gray-200 bg-gray-100 p-2">
          <div className="flex items-center gap-1.5">
            <div className="size-1.5 rounded-full bg-gray-300"></div>
            <div className="h-1.5 w-16 rounded-full bg-gray-300/80"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
